import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Poison extends Modifier {
  static readonly baseTitle = 'Poison';
  static readonly baseText = 'Deal damage equal to stacks at the end of turn, then halve.';
  static readonly baseIcon = 'poison';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Late;

  // Instance properties that can change
  title = Poison.baseTitle;
  text = Poison.baseText;
  icon = Poison.baseIcon;
  tags: Array<ModifierTags> = [...Poison.baseTags];
  priority = Poison.basePriority;

  endTurn() {
    const damage: Damage = {
      value: this.stacks,
      target: this.owner,
      source: this.owner,
      dice: [],
    };

    healthRemove(damage);

    this.halveStacks();
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Poison, Poison);
